export const claimingPhaseEnabledAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
  ],
  name: "claimingPhaseEnabled",
  outputs: [
    {
      internalType: "bool",
      name: "",
      type: "bool",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export const claimersAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
  ],
  name: "generatorClaimedByAddress",
  outputs: [
    {
      internalType: "address",
      name: "",
      type: "address",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export const claimPhaseAbi = {
  inputs: [],
  name: "claimPhase",
  outputs: [
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export const attachingEnabledAbi = {
  inputs: [],
  name: "attachingEnabled",
  outputs: [
    {
      internalType: "bool",
      name: "",
      type: "bool",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export const attachedTokenForAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
  ],
  name: "attachedTokenFor",
  outputs: [
    {
      internalType: "address",
      name: "contractAddress",
      type: "address",
    },
    {
      internalType: "uint256",
      name: "tokenIdentifier",
      type: "uint256",
    },
    {
      internalType: "uint256",
      name: "attachedAt",
      type: "uint256",
    },
    {
      internalType: "bool",
      name: "attached",
      type: "bool",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export const chipTransferAbi = {
  inputs: [
    {
      internalType: "address",
      name: "from",
      type: "address",
    },
    {
      internalType: "address",
      name: "to",
      type: "address",
    },
    {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256",
    },
    {
      internalType: "bytes",
      name: "_data",
      type: "bytes",
    },
  ],
  name: "safeTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const detachChipAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "_generatorTokenId",
      type: "uint256",
    },
  ],
  name: "detachNft",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const ownerOfAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "tokenId",
      type: "uint256",
    },
  ],
  name: "ownerOf",
  outputs: [
    {
      internalType: "address",
      name: "",
      type: "address",
    },
  ],
  stateMutability: "view",
  type: "function",
};

export const claimPrizeAbi = {
  inputs: [
    {
      internalType: "uint256",
      name: "_generatorTokenId",
      type: "uint256",
    },
  ],
  name: "claimPrize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
};

export const minAttachTimeAbi = {
  inputs: [],
  name: "minAttachTime",
  outputs: [
    {
      internalType: "uint256",
      name: "",
      type: "uint256",
    },
  ],
  stateMutability: "view",
  type: "function",
  constant: true,
};

export default {
  claimingPhaseEnabledAbi,
  claimersAbi,
  claimPhaseAbi,
  attachingEnabledAbi,
  attachedTokenForAbi,
  chipTransferAbi,
  detachChipAbi,
  claimPrizeAbi,
  minAttachTimeAbi,
};
